<ion-app>
  <ion-router-outlet id="content" main></ion-router-outlet>
  <div *ngIf="!loaded" class="loading_overlay">
    <ion-spinner name="circular" class="loading_overlay_spinner">

    </ion-spinner>
    <p class="loading_overlay_message" [innerText]="message">
    </p>
  </div>
</ion-app>
